import { SchemaFn } from '@angular/forms/signals';
import { metadataSchema } from '@shared/components/form/field/shared/form-field.function';

export interface BuildingFilter {
    filter: string;
    name: string;
    propertyIds: string[];
    /** Baujahr range — the Gt/Lt suffixes serialize as constructionYear>= / <=. */
    constructionYearGt: string;
    constructionYearLt: string;
}

export function createBuildingFilterModel(init?: Partial<BuildingFilter>): BuildingFilter {
    return {
        filter: init?.filter ?? '',
        name: init?.name ?? '',
        propertyIds: init?.propertyIds ?? [],
        constructionYearGt: init?.constructionYearGt ?? '',
        constructionYearLt: init?.constructionYearLt ?? '',
    };
}

export const buildingFilterSchema: SchemaFn<BuildingFilter> = (schema) => {
    metadataSchema(schema.filter, {
        displayName: 'Building.List.Filter.Filter',
        placeholder: 'Building.List.Filter.Filter',
    });
    metadataSchema(schema.name, {
        displayName: 'Building.List.Filter.Name',
        placeholder: 'Building.List.Filter.Name',
    });
    metadataSchema(schema.propertyIds, {
        displayName: 'Building.List.Filter.PropertyIds',
        placeholder: 'Building.List.Filter.PropertyIds',
    });
    metadataSchema(schema.constructionYearGt, {
        displayName: 'Building.List.Filter.ConstructionYear',
        placeholder: 'List.Filter.From',
    });
    metadataSchema(schema.constructionYearLt, {
        displayName: 'Building.List.Filter.ConstructionYear',
        placeholder: 'List.Filter.To',
    });
};
